import { IconAlertCircle as TablerIconAlertCircle } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconAlertCircle = /*#__PURE__*/ createOutlineIcon(
  TablerIconAlertCircle,
  'IconAlertCircle',
);
